//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CoBrokerAgentsSearchTable from "./co-broker-agents-search-table.vue";
import InlineLoader from "@Shared/components/general/inline-loader";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
import { computed, defineComponent, onMounted, ref, toRefs } from "@vue/composition-api";
import * as LenderSubmitActions from "@Broker/@Modules/clients/applications/application/store/lender-submit-actions";
import * as LenderSubmitGetters from "@Broker/@Modules/clients/applications/application/store/lender-submit-getters";
import * as LenderSubmitMutations from "@Broker/@Modules/clients/applications/application/store/lender-submit-mutations";
import { useApplicationStoreGetters, useApplicationStoreActions, useApplicationStoreMutations } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
export default defineComponent({
  name: "CoBrokerSearchStep",
  components: {
    vSelectField,
    InlineLoader,
    CoBrokerAgentsSearchTable
  },
  props: {
    currentData: {
      type: Object,
      default: () => ({})
    },
    showAgentsTable: {
      type: Boolean,
      default: false
    },
    agentSearchValid: {
      type: Boolean,
      default: false
    },
    validations: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, {
    emit
  }) {
    const displayShowFavorites = ref(false);
    const {
      showAgentsTable
    } = toRefs(props);
    const searchTableRef = ref(null);
    const loadingStates = ref({
      loadingBrokerages: false,
      searchingBrokerages: false,
      loadingMoreBrokerages: false
    });
    const searchOffset = ref(0);
    const limit = ref(20);
    const showFavorites = ref(false);
    const showAllAgents = ref(true);
    const isSearching = ref(false);
    const brokerageSearchString = ref("");
    const {
      LOAD_CO_BROKER_BROKERAGES
    } = useApplicationStoreActions([LenderSubmitActions.LOAD_CO_BROKER_BROKERAGES]);
    const {
      LOAD_CO_BROKER_FAVORITES
    } = useApplicationStoreActions([LenderSubmitActions.LOAD_CO_BROKER_FAVORITES]);
    const {
      RESET_CO_BROKER_BROKERAGES,
      RESET_CO_BROKER_AGENTS
    } = useApplicationStoreMutations([LenderSubmitMutations.RESET_CO_BROKER_BROKERAGES, LenderSubmitMutations.RESET_CO_BROKER_AGENTS]);
    const {
      CO_BROKERING_BROKERAGES,
      CO_BROKERING_BROKERAGES_COUNT,
      CO_BROKERING_BROKERAGES_LOADED,
      CO_BROKERING_LOADING_AGENTS
    } = useApplicationStoreGetters([LenderSubmitGetters.CO_BROKERING_BROKERAGES, LenderSubmitGetters.CO_BROKERING_BROKERAGES_COUNT, LenderSubmitGetters.CO_BROKERING_BROKERAGES_LOADED, LenderSubmitGetters.CO_BROKERING_AGENTS, LenderSubmitGetters.CO_BROKERING_LOADING_AGENTS]);
    const allBrokeragesLoaded = computed(() => CO_BROKERING_BROKERAGES_LOADED.value && CO_BROKERING_BROKERAGES_LOADED.value >= CO_BROKERING_BROKERAGES_COUNT.value);
    const loadBrokerages = async (loadingKey = "loadingBrokerages") => {
      if (allBrokeragesLoaded.value) return;
      loadingStates.value[loadingKey] = true;
      await LOAD_CO_BROKER_BROKERAGES({
        searchString: brokerageSearchString.value,
        offset: brokerageSearchString.value ? searchOffset.value : CO_BROKERING_BROKERAGES_LOADED.value,
        limit: limit.value
      });
      loadingStates.value[loadingKey] = false;
    };
    onMounted(() => {
      loadBrokerages();
      checkForFavorites();
    });
    const checkForFavorites = async () => {
      const offset = 0;
      const limit = 20;
      const {
        agents
      } = await LOAD_CO_BROKER_FAVORITES({
        offset,
        limit
      });
      displayShowFavorites.value = agents.length > 0;
    };
    const brokerages = computed(() => CO_BROKERING_BROKERAGES.value);
    const agentAutocomplete = ref();
    const handleSelectBrokerage = brokerage => {
      emit("change-data", {
        brokerageSelected: brokerage
      });
    };
    const searchBrokerages = search => {
      brokerageSearchString.value = search;
      searchOffset.value = 0;
      RESET_CO_BROKER_BROKERAGES();
      loadBrokerages("searchingBrokerages");
    };
    const loadMoreBrokerages = () => {
      loadBrokerages("loadingMoreBrokerages");
    };
    const resetData = () => {
      var _searchTableRef$value, _searchTableRef$value2;
      brokerageSearchString.value = "";
      searchOffset.value = 0;
      if ((_searchTableRef$value = searchTableRef.value) != null && _searchTableRef$value.resetData) (_searchTableRef$value2 = searchTableRef.value) == null ? void 0 : _searchTableRef$value2.resetData;
      RESET_CO_BROKER_BROKERAGES();
      RESET_CO_BROKER_AGENTS();
    };
    const handleDisplayShowFavorites = val => {
      displayShowFavorites.value = val;
    };
    const handleShowAllAgents = val => {
      showAllAgents.value = val;
    };
    const handleChangeAgentData = (val, key) => {
      emit("change-data", {
        [key]: val
      });
    };
    const handleClear = () => {
      showAllAgents.value = true;
      showFavorites.value = false;
      isSearching.value = false;
      emit("clear-data");
    };
    const handleClearFavorites = () => {
      emit("clear-data");
    };
    const handleSearch = async () => {
      if (showAgentsTable.value) {
        searchTableRef.value.$refs.table.refresh();
      }
      showAllAgents.value = true;
      showFavorites.value = false;
      isSearching.value = true;
      emit("search-agent");
    };
    const handleClearBrokerage = () => {
      emit("change-data", {
        brokerageSelected: {}
      });
    };
    const handleAgentSelected = agent => emit("change-data", {
      agentSelected: agent
    });
    const toggleShowFavorites = () => {
      emit("show-favorites");
      showFavorites.value = !showFavorites.value;
    };
    return {
      brokerages,
      agentAutocomplete,
      allBrokeragesLoaded,
      loadingStates,
      CO_BROKERING_LOADING_AGENTS,
      searchTableRef,
      loadBrokerages,
      loadMoreBrokerages,
      searchBrokerages,
      handleSelectBrokerage,
      handleChangeAgentData,
      handleClear,
      handleClearBrokerage,
      handleSearch,
      handleAgentSelected,
      resetData,
      showFavorites,
      showAllAgents,
      isSearching,
      toggleShowFavorites,
      handleDisplayShowFavorites,
      displayShowFavorites,
      handleShowAllAgents,
      handleClearFavorites
    };
  }
});